import React from "react";
import { Nav } from "../../Components/index";
import { Footer } from "../../Containers/index";
import LinkedinLogo from "../../assets/icons/linkedin-logo.svg";
import teams from "../../assets/json/teams.json";
import classes from "./Team.module.css";

function Team(props) {
  const teamList = teams.map((team) => {
    return (
      <figure className={classes.TeamUser} key={team.id}>
        <img src={team.img} alt="" className={classes.TeamUserImg} />
        <div>
          <p className={classes.TeamUserName}>{team.name}</p>
          <p className={classes.TeamUserPosition}>{team.position}</p>
        </div>
        <a href={`https://www.linkedin.com/in/${props.link}/`} target="/">
          <img
            src={LinkedinLogo}
            alt="Linkedin Logo"
            className={classes.LinkdeinLogo}
          />
        </a>
      </figure>
    );
  });

  return (
    <section className={classes.Team}>
      <Nav />
      <div className={classes.TeamContent}>

      <h2 className={classes.TeamTitle}>
        <span>Our</span> Team
      </h2>
      <div className={classes.TeamList}>{teamList}</div>
      </div>
      <Footer />
    </section>
  );
}

export default Team;
